import React, { useRef } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import { useLandingScrollScene, usePrefersReducedMotion } from './lib/landingMotion';

const Home = () => {
    const landingRef = useRef(null);
    const prefersReducedMotion = usePrefersReducedMotion();

    useLandingScrollScene(landingRef, { reducedMotion: prefersReducedMotion });

    return (
        <div ref={landingRef} className="site-shell landing-page">
            <Navigation />
            <main className="landing-main">
                <HeroSection />
                <FeaturesSection />
                <AboutSection />
                <ContactSection />
            </main>
        </div>
    );
};

export default Home;
